import axios from "axios";
import _ from "lodash";
import { useEffect, useState } from 'react';
import { api } from '../utils';
import { toast } from "react-toastify";

export default function useGetTestResult(payload) {
  const [testData, setTestData] = useState({ specification: {}, testResultInfo: {}, success: false});
  const [isLoading, setIsLoading] = useState(true);
  const checkPayload = () => {
    if(_.isNil(payload)) return true;
    let errors = false;
    if(payload.ItemNumber) return false;
    if(!payload.SpecNumber || !payload.TestId) return true; //both null and empty strings are falsey
    return errors;
  }

  useEffect(() => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    if(checkPayload()) {
       setIsLoading(false);
        toast.info("your parameters have gone missing, please try again.");
        return;
    }
    if(payload.ItemNumber) {
      api.postS(`Quality/AddNewTest`, payload, source.token)
      .then(response => {
        if(response.data.success){
            setTestData({
                specification: response.data.TestInfo.item1,
                testResultInfo: response.data.TestInfo.item2,
                success: true
            });
        } else {
            toast.error("failed to render test results please contact your admin.")
           throw new Error("failed to load test results");
        }
      })
      .catch(api.catchHandler)
      .finally(() => setIsLoading(false));
    } else {
      api.postS(`Quality/AddEditQualityTest`, payload, source.token)
      .then(response => {
        if(response.data.success){
            setTestData({
                specification: response.data.TestInfo.item1,
                testResultInfo: response.data.TestInfo.item2,
                success: true
            });
        } else {
            toast.error("failed to render test results please contact your admin.")
           throw new Error("failed to load test results");
        }
      })
      .catch(api.catchHandler)
      .finally(() => setIsLoading(false));
    }
      return () => { 
        source.cancel("axios request cancelled"); 
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload]);

  return [testData.specification, testData.testResultInfo, isLoading, testData.success];
}

